import { useMutation, useQuery } from '@tanstack/react-query';
import { queryKeys } from 'react-query/constant';
import {
  customDateHypo,
  customDateHypoList,
  HypoInfoApi,
  HypoInfoListApi
} from '../services/hypo-service';

export const useHypo = ({ patientId, daysAgo }) => {
  return useQuery(
    [queryKeys.hypoInfo, patientId, daysAgo],
    () => HypoInfoApi(patientId, daysAgo),
    { enabled: typeof daysAgo === 'number' }
  );
};

export const useHypoList = ({ patientId, daysAgo }) => {
  return useQuery(
    [queryKeys.hypoList, patientId, daysAgo],
    () => HypoInfoListApi(patientId, daysAgo),
    { enabled: typeof daysAgo === 'number' }
  );
};

export const useCustomDateHypo = (date) => {
  return useMutation({
    mutationFn: customDateHypo,
    enabled: date.from && date.to
  });
};

export const useCustomDateHypoList = (date) => {
  return useMutation({
    mutationFn: customDateHypoList,
    enabled: date.from && date.to
  });
};
